import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ajax-call-intercepter',
	templateUrl:'./AjaxCallIntercepterPluginCompPage.html',
	styles: [],
	styleUrls:['./AjaxCallIntercepterPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AjaxCallIntercepterPluginCompPage
{
	mdContent_759 = `\`\`\`java
import com.jwebmp.client.AjaxCallIntercepter;
\`\`\``;
	mdContent_760 = `\`\`\`java
public class AuthInterceptor implements AjaxCallIntercepter&lt;AuthInterceptor&gt; {
    @Override
    public void intercept(AjaxCall&lt;?&gt; call, AjaxResponse&lt;?&gt; response) {
        if (!isAuthenticated()) {
            response.addReaction(new AjaxResponseReaction("redirect", "/login"));
        }
    }
}
\`\`\``;
}
